import { BitfStrapiModel } from '@common/libs/bitforce/core/models';
import { EntryGoods } from './entry-goods.model';
import { WorkOrder } from './work-order.model';

export class PurchaseRequest extends BitfStrapiModel {
  wplrda: number;
  wplrdaDate: Date;
  bobcbe: number;
  bobcbeDate: Date;
  supplier: string;
  omsCode: string;
  offerAmount: number;
  entryGoods: EntryGoods[];
  workOrder: WorkOrder;

  constructor(data: Partial<PurchaseRequest> = {}) {
    super({ data });

    if (data.entryGoods) {
      this.entryGoods = data.entryGoods?.map(entryGoods => new EntryGoods(entryGoods));
    }

    if (data.workOrder) {
      this.workOrder = new WorkOrder(data.workOrder);
    }
  }

  get serialised() {
    return {
      omsCode: this.omsCode,
      offerAmount: this.offerAmount,
    };
  }
}
